import PublicationCard from './PublicationCard';
export default PublicationCard;
